/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../components/Loading";
import _ from "lodash";
import { DateTimePicker } from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField as MuiTextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  Alert,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { Formik } from "formik";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import swal from "sweetalert";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const TextFieldSpacing = styled(MuiTextField)(spacing);

const TextField = styled(TextFieldSpacing)`
  width: 100%;
`;

const _checkLength = (value, length) => {
  value = value.toString();
  value = value.slice(0, length);
  return parseInt(value);
};

function FormDetails({ user, missingPermissions }) {
  const navigate = useNavigate();
  const [plates, setPlates] = React.useState([{}]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [selectedPlates, setSelectedPlates] = useState([]);
  const [customerUsers, setCustomerUsers] = useState([]);
  const [cost, setCost] = useState(0);

  const [loader, setLoader] = useState(false);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const removePlate = (i, id) => {
    if (id) {
      setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    }
    setPlates((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
  };

  const plateHandle = (i, obj) => (e) => {
    let plate = [...plates];
    if (obj === "not_to_bill") {
      plate[i][obj] = e.target.checked;
    } else {
      if (obj === "gripper") {
        if (e.target.value <= 99.99 && e.target.value >= 0.0) {
          plate[i][obj] = parseFloat(e.target.value);
        }
      } else {
        plate[i][obj] = e.target.value;
      }
    }
    setPlates(plate);
    let selected = [];
    plate.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  };

  const totalPrice = () => {
    let totalCost = 0;
    selectedPlates.map((plate, i) => {
      const id = plate;
      inventory.map((inv) => {
        if (inv.plate_id === id) {
          if (plates[i].bake && plates[i].printout && plates[i].quantity) {
            totalCost += parseInt(plates[i].bake) * parseInt(inv.baking_cost);
            totalCost +=
              parseInt(plates[i].printout) * parseInt(inv.print_cost);
            totalCost +=
              parseInt(plates[i].quantity) * parseInt(inv.selling_cost);
          }
        }
      });
    });
    setCost(totalCost);
  };

  useEffect(() => {}, [selectedPlates]);

  const addPlate = () => {
    setPlates((prev) => [...prev, {}]);
  };

  const getInventory = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/customer_user/customer_company/${user.customer_company._id}/plate`,
        config
      );
      if (data.success) {
        setInventory(data.data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getInventory();
  }, []);

  const getCustomerUsers = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      const { data } = await axios.get(`/api/v1/customer_user/ops`, config);
      if (data.success) {
        setCustomerUsers(data.data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getCustomerUsers();
  }, []);

  const requestJob = async (values, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/customer_user/${user?.customer_company?._id}/jobs/request`,
        {
          customer_company: user?.customer_company?._id,
          customer_company_user: values.customer_company_user,
          customer_contact_number: values.customer_contact_number,
          name: values.name,
          delivery: values.delivery,

          pc_ap: values.pc_ap,
          cut: values.cut,
          open_height: values.open_height,
          open_width: values.open_width,
          page: values.page,
          binding_style: values.binding_style,
          received_date: new Date(values.recieved_date).toISOString(),
          required_date: new Date(values.required_date).toISOString(),
          total_form: _checkLength(values.total_form, 4),
          fb: _checkLength(values.fb, 4),
          sb: _checkLength(values.sb, 4),
          dg: _checkLength(values.dg, 4),
          os: _checkLength(values.os, 4),
          instructions: values.instructions,
          plates,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        resetForm({ values: "" });
        setPlates([]);
        setCost(0);
        snackRef.current.click();
        navigate("/dashboard/jobs", {
          state: { message: "Job Requested Successfully", success: true },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  const setGripper = (id, i) => {
    let gripper;
    inventory.map((plate) => {
      if (plate.plate_id === id) {
        gripper = plate.gripper;
      }
    });
    let plate = [...plates];
    plate[i]["gripper"] = gripper;
    setPlates(plate);
  };
  return (
    <>
      {/* General Details */}
      <Formik
        initialValues={{
          customer_company_user: "",
          customer_contact_number: "",

          delivery:
            user?.customer_company?.addresses[
              user?.customer_company?.default_address
            ] || "",
          name: "",
          pc_ap: "",
          total_form: "",
          cut: "",
          open_height: "",
          open_width: "",
          page: "",
          binding_style: "",
          required_date: "",
          recieved_date: "",
          fb: "",
          sb: "",
          dg: "",
          os: "",
          instructions: "",
        }}
        validationSchema={Yup.object().shape({
          customer_company_user: Yup.string().required(
            "Customer Company user is required"
          ),
          customer_contact_number: Yup.string().required(
            "Customer Company Number is required"
          ),
          delivery: Yup.object().required("Address is required"),
          name: Yup.string().max(255).required("name is required"),
          pc_ap: Yup.string().max(255).required("PC/AP is required"),
          // total_form: Yup.string()
          //   .matches(
          //     /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          //     "Total Form should be in range 1 - 3999"
          //   )
          //   .required("Total Form is required"),
          cut: Yup.string().max(255).required("cut is required"),
          open_height: Yup.string()
            .max(255)
            .required("Open-Height is required"),
          open_width: Yup.string().max(255).required("Open-Width is required"),
          page: Yup.string().required("page is required"),
          binding_style: Yup.string()
            .max(255)
            .required("binding style is required"),
          required_date: Yup.string().required("Delivery Date is required"),
          recieved_date: Yup.date().required("Recieved date is required"),
          fb: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "F/B should be in range 1 - 3999"
          ),
          sb: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "S/B should be in range 1 - 3999"
          ),
          dg: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "D/G should be in range 1 - 3999"
          ),
          os: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "O/S should be in range 1 - 3999"
          ),
          instructions: Yup.string(),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            requestJob(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            console.log(message);
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values,
        }) => (
          <>
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              autoHideDuration={2000}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Job Requested Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <form noValidate onSubmit={handleSubmit} autoComplete="off">
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item lg={12} md={12} xs={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            General Details
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            value={user?.customer_company?.name}
                            inputProps={{ readOnly: true }}
                            label="Customer Company"
                          />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.delivery && errors.delivery)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={user?.customer_company?.addresses}
                              defaultValue={values?.delivery}
                              value={values?.delivery}
                              onChange={(event, newValue) => {
                                setFieldValue("delivery", newValue || "");
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option?.address_line_one}, ${option?.address_line_two}, ${option?.city}, ${option?.state}, ${option?.pincode}, India`
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(
                                    touched.delivery && errors.delivery
                                  )}
                                  helperText={
                                    touched.delivery && errors.delivery
                                  }
                                  label="Delivery"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.customer_company_user &&
                                errors.customer_company_user
                            )}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={customerUsers}
                              value={values.customer_company_user.name}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "customer_company_user",
                                  newValue._id || ""
                                );
                                setFieldValue(
                                  "customer_contact_number",
                                  newValue.phone_number || ""
                                );
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option ? option.name : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(
                                    touched.customer_company_user &&
                                      errors.customer_company_user
                                  )}
                                  helperText={
                                    touched.customer_company_user &&
                                    errors.customer_company_user
                                  }
                                  label="Customer Company User"
                                />
                              )}
                            />

                            {/* <Select
                              name="customer_company_user"
                              id="search-field"
                              value={values.customer_company_user || ""}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              displayEmpty
                            >
                              <MenuItem value={""} disabled>
                                Select Customer Company User
                              </MenuItem>
                              {customerUsers.length &&
                                customerUsers.map((user) => {
                                  return (
                                    <MenuItem value={user._id}>
                                      {user.name}
                                    </MenuItem>
                                  );
                                })}
                            </Select> */}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <TextField
                            name="customer_contact_number"
                            fullWidth
                            inputProps={{ readOnly: true }}
                            value={values.customer_contact_number}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.customer_contact_number &&
                                errors.customer_contact_number
                            )}
                            helperText={
                              touched.ap_contact_number &&
                              errors.ap_contact_number
                            }
                            id="search-field"
                            label="Customer Contact Number"
                          />
                        </Grid>

                        <Grid item lg={12} xs={12} md={12}>
                          <TextField
                            name="name"
                            fullWidth
                            value={values.name}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            onChange={handleChange}
                            id="search-field"
                            label="Job Name"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            name="pc_ap"
                            value={values.pc_ap}
                            onBlur={handleBlur}
                            error={Boolean(touched.pc_ap && errors.pc_ap)}
                            helperText={touched.pc_ap && errors.pc_ap}
                            onChange={handleChange}
                            id="search-field"
                            label="PC-AP"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="total_form"
                            value={values.total_form}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.total_form && errors.total_form
                            )}
                            helperText={touched.total_form && errors.total_form}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("total_form")(e);
                              }
                            }}
                            id="search-field"
                            label="Total Form"
                          />
                        </Grid>
                        <Grid item md={6} lg={3} xs={12}>
                          <TextField
                            name="cut"
                            value={values.cut}
                            onBlur={handleBlur}
                            error={Boolean(touched.cut && errors.cut)}
                            helperText={touched.cut && errors.cut}
                            onChange={handleChange}
                            id="search-field"
                            label="Cut"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            name="open_height"
                            value={values.open_height}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_height && errors.open_height
                            )}
                            helperText={
                              touched.open_height && errors.open_height
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Height"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            name="open_width"
                            value={values.open_width}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_width && errors.open_width
                            )}
                            helperText={touched.open_width && errors.open_width}
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Width"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="page"
                            value={values.page}
                            onBlur={handleBlur}
                            error={Boolean(touched.page && errors.page)}
                            helperText={touched.page && errors.page}
                            onChange={handleChange}
                            id="search-field"
                            label="Page"
                          />
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <FormControl fullWidth error={touched.recieved_date}>
                            <DateTimePicker
                              name="recieved_date"
                              renderInput={(props) => (
                                <TextField
                                  {...props}
                                  error={
                                    touched.recieved_date &&
                                    errors.recieved_date
                                  }
                                />
                              )}
                              label="Recieved Date"
                              value={values.recieved_date || null}
                              onChange={(newValue) => {
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate.getHours());
                                var minute = parseInt(
                                  selectedDate.getMinutes()
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("recieved_date", date);
                              }}
                              onBlur={handleBlur}
                            />
                            {/* <FormHelperText>Select Recieved Date</FormHelperText> */}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <FormControl
                            fullWidth
                            // error={Boolean(
                            //   touched.required_date && errors.required_date
                            // )}
                          >
                            <DateTimePicker
                              name="required_date"
                              format="YYYY-MM-DD"
                              renderInput={(props) => (
                                <TextField
                                  {...props}
                                  error={
                                    touched.required_date &&
                                    errors.required_date
                                  }
                                />
                              )}
                              label="Delivery Date"
                              value={values.required_date || null}
                              onChange={(newValue) => {
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate.getHours());
                                var minute = parseInt(
                                  selectedDate.getMinutes()
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("required_date", date);
                              }}
                              onBlur={handleBlur}
                            />
                            {/* <FormHelperText>Select Delivery Date</FormHelperText> */}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="fb"
                            value={values.fb}
                            onBlur={handleBlur}
                            error={Boolean(touched.fb && errors.fb)}
                            helperText={touched.fb && errors.fb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("fb")(e);
                              }
                            }}
                            id="search-field"
                            label="F/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="sb"
                            value={values.sb}
                            onBlur={handleBlur}
                            error={Boolean(touched.sb && errors.sb)}
                            helperText={touched.sb && errors.sb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("sb")(e);
                              }
                            }}
                            id="search-field"
                            label="S/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="dg"
                            value={values.dg}
                            onBlur={handleBlur}
                            error={Boolean(touched.dg && errors.dg)}
                            helperText={touched.dg && errors.dg}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("dg")(e);
                              }
                            }}
                            id="search-field"
                            label="D/G"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="number"
                            name="os"
                            value={values.os}
                            onBlur={handleBlur}
                            error={Boolean(touched.os && errors.os)}
                            helperText={touched.os && errors.os}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("os")(e);
                              }
                            }}
                            id="search-field"
                            label="O/S"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.binding_style && errors.binding_style
                            )}
                          >
                            <Select
                              name="binding_style"
                              id="search-field"
                              value={values.binding_style}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value={""} disabled>
                                Select Binding Style
                              </MenuItem>
                              <MenuItem value={"perfect"}>Perfect</MenuItem>
                              <MenuItem value={"center_pinning"}>
                                Center Pining
                              </MenuItem>
                              <MenuItem value={"perfect_section"}>
                                Perfect Section
                              </MenuItem>
                              <MenuItem value={"wiro"}>Wiro</MenuItem>
                              <MenuItem value={'cut_n_go'}>Cut N Go</MenuItem>
                              <MenuItem value={'punch_n_go'}>Punch N Go</MenuItem>
                            </Select>
                            {/* <FormHelperText>Select binding Style</FormHelperText> */}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            multiline
                            name="instructions"
                            value={values.instructions}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.instructions && errors.instructions
                            )}
                            helperText={
                              touched.instructions && errors.instructions
                            }
                            onChange={handleChange}
                            label="Job Instructions"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                {/* Plate Details */}
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h6" gutterBottom>
                            Plate Details
                          </Typography>
                        </Grid>

                        {plates.map((pl, i) => {
                          const check = [];
                          if (selectedPlates.length) {
                            selectedPlates.map((p) => {
                              check.push(p);
                            });
                          }
                          return (
                            <>
                              <Grid item xs={11} md={11} lg={11}>
                                <FormControl fullWidth>
                                  <Select
                                    required
                                    value={pl.plate_id || ""}
                                    onChange={(e) => {
                                      plateHandle(i, "plate_id")(e);
                                      setGripper(e.target.value, i);
                                      totalPrice();
                                    }}
                                    displayEmpty
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                  >
                                    <MenuItem value={""} disabled>
                                      Select Plate
                                    </MenuItem>
                                    {inventory.map((plate) => {
                                      if (check.includes(plate.plate_id)) {
                                        return (
                                          <MenuItem
                                            disabled
                                            value={plate.plate_id}
                                          >
                                            Size- {plate.height}X{plate.width}X
                                            {plate.thickness} || Baking Cost-
                                            {plate?.baking_cost === undefined
                                              ? `Not yet added`
                                              : plate?.baking_cost}{" "}
                                            || Print Cost-
                                            {plate.print_cost === undefined
                                              ? `Not yet added`
                                              : plate.print_cost}
                                          </MenuItem>
                                        );
                                      } else {
                                        return (
                                          <MenuItem value={plate.plate_id}>
                                            Size- {plate.height}X{plate.width}X
                                            {plate.thickness} || Baking Cost-
                                            {plate?.baking_cost === undefined
                                              ? `Not yet added`
                                              : plate?.baking_cost}{" "}
                                            || Print Cost-
                                            {plate.print_cost === undefined
                                              ? `Not yet added`
                                              : plate.print_cost}{" "}
                                          </MenuItem>
                                        );
                                      }
                                    })}
                                  </Select>
                                  {/* <FormHelperText>Select Plate</FormHelperText> */}
                                </FormControl>
                              </Grid>
                              <Grid item xs={1} md={1} lg={1}>
                                <div style={{ marginTop: 8 }}>
                                  <CloseIcon
                                    onClick={() => {
                                      removePlate(i, pl.plate_id);
                                    }}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  id="search-field"
                                  type="number"
                                  value={pl.gripper || ""}
                                  onChange={plateHandle(i, "gripper")}
                                  label="Gripper"
                                  // helperText="Gripper"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  type="number"
                                  id="search-field"
                                  value={pl.screen}
                                  onChange={plateHandle(i, "screen")}
                                  label="Screen"
                                  // helperText="Screen"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  type="number"
                                  id="search-field"
                                  value={pl.set}
                                  onChange={plateHandle(i, "set")}
                                  label="Set"
                                  // helperText="Set"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  id="standard-number"
                                  label="ctp"
                                  value={pl.ctp_plate_count}
                                  onChange={plateHandle(i, "ctp_plate_count")}
                                  type="number"
                                  // helperText="Please enter ctp"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  id="standard-number"
                                  label="Bake Quantity"
                                  value={pl.bake}
                                  onChange={(e) => {
                                    plateHandle(i, "bake")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  fullWidth
                                  id="standard-number"
                                  label="Printout Quantity"
                                  value={pl.printout}
                                  onChange={(e) => {
                                    plateHandle(i, "printout")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={3}>
                                <TextField
                                  disabled
                                  id="standard-number"
                                  label="Total Quantity"
                                  value={pl.quantity}
                                  onChange={(e) => {
                                    plateHandle(i, "quantity")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                  // helperText="Please enter total quantity"
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12} lg={3} md={3}>
                                <FormControl
                                  fullWidth
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={plateHandle(i, "not_to_bill")}
                                        checked={pl.not_to_bill || false}
                                      />
                                    }
                                    label={"Not to Bill"}
                                  />
                                </FormControl>
                                <br />
                                <br />
                              </Grid>
                            </>
                          );
                        })}
                        <Grid item xs={12} lg={12} md={12}>
                          <Button
                            onClick={addPlate}
                            mr={2}
                            variant="contained"
                            color="primary"
                            disabled={missingPermissions.length > 0}
                          >
                            Add Plate
                            <AddIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                {/* <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h6" gutterBottom>
                            Job Cost
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          The Total Job Cost is {cost}
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card> */}

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting || missingPermissions.length > 0}
                >
                  Request Job
                </Button>
              </form>
            ) : (
              <Loading />
            )}
          </>
        )}
      </Formik>
    </>
  );
}

function RequestJob({ auths }) {
  const [user, setUser] = useState([]);
  const [loader, setLoader] = useState(true);
  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = [
    "view_customer_company_user_profile",
    "view_customer_company_user_list",
    "request_new_job",
  ];

  useEffect(() => {
    if (auths?.user) {
      setUser(auths.user);
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error"
          );
        }
      }
    }
    setLoader(false);
  }, [auths.user]);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              REQUEST JOB
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/jobs">
                All Jobs
              </Link>
              <Typography>Request Job</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <GeneralDetails /> */}
            <FormDetails missingPermissions={missingPermissions} user={user} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(RequestJob);
